var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 487,
    height: 495,
    viewBox: "0 0 487 495",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "banner-verify"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 634481"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M21.5889 243.647C22.4822 384.754 201.472 456.87 314.723 473.841C427.974 490.812 560.251 306.751 406.045 167.268C251.84 27.7851 297.055 36.5304 177.949 21.4967C58.8421 6.463 20.932 139.869 21.5889 243.647Z",
    stroke: "#0A7525",
    strokeWidth: 4,
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M358.238 394.057H222.268C214.953 394.057 209 386.291 209 376.729V168.828C209 159.266 214.953 151.5 222.268 151.5H358.238C365.568 151.5 371.506 159.266 371.506 168.828V376.729C371.506 386.291 365.568 394.057 358.238 394.057ZM222.268 157.315C217.406 157.315 213.432 162.492 213.432 168.848V376.748C213.432 383.104 217.406 388.281 222.268 388.281H358.238C363.115 388.281 367.074 383.104 367.074 376.748V168.848C367.074 162.492 363.115 157.315 358.238 157.315H222.268Z",
    fill: "#0A7525"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M344.31 196.723H237.24C235.101 196.723 233.385 194.664 233.385 192.112C233.385 189.56 235.101 187.5 237.24 187.5H344.31C346.423 187.5 348.139 189.56 348.139 192.112C348.139 194.664 346.423 196.723 344.31 196.723Z",
    fill: "#0A7525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M307.981 219.505H237.264C235.126 219.505 233.41 217.445 233.41 214.893C233.41 212.341 235.126 210.281 237.264 210.281H307.981C310.12 210.281 311.836 212.341 311.836 214.893C311.836 217.445 310.12 219.505 307.981 219.505Z",
    fill: "#0A7525"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M344.31 261.471H237.24C235.101 261.471 233.385 259.412 233.385 256.86C233.385 254.308 235.101 252.248 237.24 252.248H344.31C346.423 252.248 348.139 254.308 348.139 256.86C348.139 259.412 346.423 261.471 344.31 261.471Z",
    fill: "#0A7525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M307.981 284.284H237.264C235.126 284.284 233.41 282.224 233.41 279.672C233.41 277.12 235.126 275.061 237.264 275.061H307.981C310.12 275.061 311.836 277.12 311.836 279.672C311.836 282.224 310.12 284.284 307.981 284.284Z",
    fill: "#0A7525"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M344.31 326.62H237.24C235.101 326.62 233.385 324.56 233.385 322.008C233.385 319.456 235.101 317.396 237.24 317.396H344.31C346.423 317.396 348.139 319.456 348.139 322.008C348.139 324.56 346.423 326.62 344.31 326.62Z",
    fill: "#0A7525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M307.981 349.432H237.264C235.126 349.432 233.41 347.372 233.41 344.821C233.41 342.269 235.126 340.209 237.264 340.209H307.981C310.12 340.209 311.836 342.269 311.836 344.821C311.836 347.372 310.12 349.432 307.981 349.432Z",
    fill: "#0A7525"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.123 357.12L401.227 406.005C401.744 406.866 400.983 407.927 399.979 407.741L382.164 404.642L376.025 421.153C375.666 422.099 374.361 422.214 373.83 421.339L351.023 383.026L328.215 421.339C327.699 422.2 326.379 422.085 326.021 421.153L319.881 404.642L302.08 407.741C301.061 407.913 300.301 406.866 300.818 406.005L326.767 362.413L355.01 371.694L372.137 357.105L372.123 357.12Z",
    fill: "#0A7525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.891 374.061C395.848 371.722 399.033 362.212 394.83 356.374C393.051 353.907 393.051 350.794 394.83 348.327C399.047 342.474 395.848 332.964 388.891 330.641C385.965 329.665 384.072 327.14 384.014 324.128C383.871 316.999 375.537 311.118 368.494 313.198C365.539 314.073 362.469 313.112 360.604 310.716C356.172 305.022 345.859 305.022 341.426 310.716C339.562 313.112 336.506 314.073 333.537 313.198C326.494 311.118 318.16 316.999 318.016 324.128C317.959 327.126 316.066 329.651 313.139 330.641C306.182 332.979 303.012 342.489 307.215 348.327C308.979 350.794 308.979 353.907 307.215 356.374C302.998 362.227 306.182 371.737 313.139 374.061C316.066 375.036 317.959 377.561 318.016 380.573C318.174 387.702 326.494 393.583 333.537 391.503C336.506 390.628 339.562 391.589 341.426 393.985C345.859 399.679 356.172 399.679 360.604 393.985C362.469 391.589 365.539 390.628 368.494 391.503C375.537 393.583 383.885 387.702 384.014 380.573C384.072 377.575 385.965 375.05 388.891 374.061Z",
    fill: "#0A7525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M351.008 381.676C367.705 381.676 381.246 368.55 381.246 352.357C381.246 336.164 367.705 323.037 351.008 323.037C334.312 323.037 320.771 336.164 320.771 352.357C320.771 368.55 334.312 381.676 351.008 381.676Z",
    fill: "#EFF4F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.728 339.978C364.176 338.572 366.529 338.572 367.978 339.978C369.427 341.384 369.427 343.665 367.978 345.07L347.695 364.736C346.246 366.142 343.894 366.142 342.445 364.736C342.287 364.579 342.158 364.421 342.015 364.249L333.752 354.15C332.476 352.601 332.748 350.335 334.34 349.101C335.947 347.867 338.271 348.126 339.547 349.675L345.371 356.79L362.713 339.978H362.728Z",
    fill: "#0A7525"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 634480"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M251.091 384.012C251.091 384.012 250.539 455.32 203.54 474.5H203.528C203.482 474.468 203.447 474.455 203.394 474.435C156.534 455.19 156 384.012 156 384.012L203.394 367.545L203.54 367.5L251.091 384.012Z",
    fill: "#0A7525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M199.357 437.824L177.972 420.327C176.252 418.922 176.014 416.403 177.449 414.707C178.878 413.01 181.429 412.777 183.154 414.188L198.927 427.101L227.179 400.04C228.782 398.505 231.35 398.537 232.907 400.117C234.47 401.697 234.435 404.229 232.832 405.764L199.351 437.83L199.357 437.824Z",
    fill: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    opacity: 0.26,
    d: "M55.8576 312.126C48.9556 309.016 18.3913 294.442 27.5337 283.918C35.6838 274.539 49.5829 297.886 55.0078 307.987C52.5658 294.596 54.2226 286.496 54.6022 284.959C49.5951 275.496 37.3378 249.9 49.7767 247.41C62.3308 244.896 58.9711 274.015 57.3668 284.508C57.5096 284.815 57.563 285.167 57.4693 285.516C57.4372 285.629 55.3642 293.717 57.9571 307.809C60.1056 297.115 66.7174 270.224 77.8023 276.355C90.0826 283.151 64.3073 306.182 58.6153 311.066C59.765 316.217 61.5082 322.043 64.1532 328.508C65.0223 330.62 66.0111 332.847 67.1141 335.167C69.2037 325.262 76.3224 296.598 87.6527 303.103C99.6601 309.997 74.3838 332.106 68.1608 337.304C72.0948 345.206 77.4804 354.19 84.8439 364.082C86.6497 355.172 93.8129 324.382 105.525 331.082C117.674 338.038 91.7304 360.6 85.8838 365.471C91.0279 372.273 97.119 379.492 104.299 387.071C105.191 378.118 109.261 346.531 121.591 352.024C134.374 357.711 110.758 382.872 105.457 388.291C111.145 394.229 117.512 400.38 124.623 406.727C125.006 398.529 127.363 365.327 140.201 370.291C153.45 375.408 130.156 402.533 125.626 407.625C132.086 413.346 139.138 419.219 146.885 425.226C147.282 416.885 149.664 383.921 162.457 388.868C175.612 393.95 152.751 420.711 147.991 426.075C153.038 429.966 158.34 433.909 163.963 437.905C164.552 438.326 164.749 439.108 164.451 439.746C164.419 439.818 164.382 439.892 164.329 439.963C163.877 440.629 162.969 440.788 162.317 440.318C156.688 436.318 151.38 432.371 146.327 428.476C140.943 431.859 110.597 450.187 107.157 436.135C103.856 422.657 136.632 426.306 144.984 427.448C137.11 421.334 129.949 415.353 123.383 409.532C115.738 414.204 88.6477 429.686 85.4078 416.448C82.3447 403.934 110.384 406.189 121.09 407.488C114.678 401.697 108.886 396.07 103.648 390.617C96.0804 392.173 63.3361 398.104 64.7403 384.152C66.0108 371.512 91.1132 382.869 101.044 387.879C94.3007 380.672 88.5423 373.793 83.6121 367.281C75.6306 367.673 42.7563 368.5 46.1584 355.015C49.2002 342.964 71.5749 357.164 81.0273 363.799C74.3354 354.592 69.3449 346.177 65.6138 338.701C57.2534 337.027 25.9578 329.884 32.3527 317.796C37.8892 307.325 55.0306 324.446 63.1864 333.581C62.5251 332.114 61.9079 330.683 61.3484 329.301C58.7744 322.958 57.0478 317.237 55.8746 312.134L55.8576 312.126Z",
    fill: "#0A7525"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3",
    x: 3.5,
    y: 112,
    width: 120,
    height: 79,
    rx: 11.5,
    fill: "#6EB954",
    stroke: "#0A7525",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 634482"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4",
    x: 7,
    y: 77.5,
    width: 118,
    height: 29,
    rx: 5,
    fill: "#0A7525"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5",
    x: 7,
    y: 69.5,
    width: 66,
    height: 25,
    rx: 5,
    fill: "#0A7525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M125 93.5H79.76L67 84.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerVerify);
export default __webpack_public_path__ + "static/media/banner-verify.e71a6fda0eb9bd2d57d72b70ee09b293.svg";
export { ForwardRef as ReactComponent };